import NotFoundPage from "@/pages/NotFoundPage";
import { useTheme } from "@/context/useTheme";
import { ConfigProvider } from "antd";
import { Route, Routes } from "react-router-dom";
import "@/projects/Civi_Circle_Admin/styles/style.css";
import MMNavigationRoutes from "./utils/navigationRoutes";
import MMLayout from "./layouts/MMLayout";
import MMRoutes from "./utils/routes";

const MMApp = () => {
  const { theme } = useTheme();
  return (
    <ConfigProvider
      theme={{
        hashed: false,
        ...theme,
      }}
      componentSize="large"
    >
      <div className="mm-app" style={{ height: "48px" }}>
        <Routes>
          <Route element={<MMLayout />}>
            {Object.values(MMRoutes).map(({ path, component: Page }) => (
              <Route key={path} path={path} element={<Page />} />
            ))}
            <Route
              path="*"
              element={
                <NotFoundPage
                  buttonLink={"/mm/" + MMNavigationRoutes.MEMBER_LIST}
                />
              }
            />
          </Route>
        </Routes>
      </div>
    </ConfigProvider>
  );
};

export default MMApp;
